import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "GlobalComparator" })
export default class GlobalComparator extends Vue {
    public localizer: any = Localizer;
    public validationErrors: any[] = [];
    public entryInfoList: any[] = [];
    public isLoading: boolean = false;
    public isDetailVisible: boolean = false;

    get comparatorProducts() {
        return this.$store.getters["globalComparatorStore/comparatorProducts"];
    }

    get isUpdated() {
        return this.$store.getters["globalComparatorStore/isUpdated"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isUpdated") async onIsUpdatedChanges() {
        if (this.isDetailVisible && this.comparatorProducts.length !== 0) {
            await this.getData();
            for (const item of this.comparatorProducts) {
                this.$nextTick(function () {
                    this.setGallery(item.bremboCode);
                });
            }
        }
    }

    public async created() {
        await this.$store.dispatch("globalComparatorStore/getComparatorProducts");
    }

    public async showDetail() {
        await this.getData();
        let comparator = document.getElementById("Compared");
        comparator.classList.toggle("active");
        if (comparator.classList.contains("active")) {
            this.isDetailVisible = true;
            document.body.classList.add("overflow");
        } else {
            comparator.classList.remove("active");
            this.isDetailVisible = false;
            document.body.classList.remove("overflow");
        }

        for (const item of this.comparatorProducts) {
            this.$nextTick(function () {
                this.setGallery(item.bremboCode);
            });
        }
    }

    public async removeItem(bremboCode: string) {
        if (this.comparatorProducts.length === 1) {
            let comparator = document.getElementById("Compared");
            comparator.classList.remove("active");
            this.isDetailVisible = false;
            document.body.classList.remove("overflow");
        }
        await this.$store.dispatch("globalComparatorStore/removeEntry", { bremboCode: bremboCode });
        GTagHelper.sendCustomEvent("click", "comparator_delete");
    }

    public async removeAllItem() {
        let comparator = document.getElementById("Compared");
        comparator.classList.remove("active");
        this.isDetailVisible = false;
        document.body.classList.remove("overflow");

        await this.$store.dispatch("globalComparatorStore/removeAllEntry");
        GTagHelper.sendCustomEvent("click", "comparator_delete");
    }

    public async getData() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.GlobalComparator_GetProducts, { globalComparatorItems: this.comparatorProducts })).data;
            this.entryInfoList = result.entryInfoList;

        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public hasDifferentValue(propertyName: string): boolean {
        const firstValue = this.entryInfoList[0].product[propertyName];

        for (let i = 1; i < this.entryInfoList.length; i++) {
            if (this.entryInfoList[i].product[propertyName] !== firstValue) {
                return true;
            }
        }
        return false;
    }

    public hasNonNullNotEmptyProperty(propertyName: string): boolean {
        return this.entryInfoList.some(obj => {
            return Object.keys(obj.product).some(key =>
                key === propertyName &&
                obj.product[key] !== undefined &&
                obj.product[key] !== null &&
                obj.product[key] !== ''
            );
        });
    }

    public parseNumber(value: any): string {
        if (!value && value !== 0) {
            return "";
        }
        return value.toString().replace(".", ",");
    }

    public setGallery(bremboCode: string) {
        let carosel = document.getElementById("CarouselComparator_" + bremboCode);
        if (carosel) {
            new (<any>window).Carousel(carosel, {
                infinite: false,
                Dots: false,
                transition: "slide"
            });
        }

        (<any>window).Fancybox.bind("[data-fancybox='comparator_" + bremboCode + "']", {
            dragToClose: false,
            Images: {
                zoom: true,
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                },
            },
            Thumbs: {
                type: 'classic',
            },
        });

        (<any>window).Fancybox.bind("[data-fancybox]", {});
    }
}